
// Youtube player, not using the regular implementation of youtube iframe api since the play function doesn't work
// https://www.digitalredpanther.com/blog/play-pause-stop-youtube-embed
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class YoutubeVideo extends Vue {
  @Prop() videoId: string

  showVideo = false

  playVideo(): void {
    this.showVideo = true
    const playMessage = { event: 'command', func: 'playVideo', args: '' }
    const iframe = this.$el.querySelector('iframe') as HTMLIFrameElement
    if(iframe && iframe.contentWindow) iframe.contentWindow.postMessage(JSON.stringify(playMessage), '*');
  }

  resetVideo(): void {
    this.showVideo = false
    const stopMessage = { event: 'command', func: 'stopVideo', args: '' }
    const iframe = this.$el.querySelector('iframe') as HTMLIFrameElement
    if(iframe && iframe.contentWindow) iframe.contentWindow.postMessage(JSON.stringify(stopMessage), '*');
  }
}
